import request from "@/utils/request.js";

// 获取项目列表
export const getReportList = params => {
  return request({
    method: "get",
    url: "/product/list",
    params
  });
};

// 创建项目
export const addReport = data => {
  return request({
    method: "post",
    url: "/product/store",
    data
  });
};

// 重新生成报告
export const recreateReport = productId => {
  return request({
    method: "post",
    url: "/product/recreate",
    data: {
      productId
    }
  });
};

// 删除项目
export const delReport = productId => {
  return request({
    method: "post",
    url: "/product/destory",
    data: { productId }
  });
};

// 获取报告状态
export const getreport = id => {
  return request({
    method: "post",
    url: "/report/getreport",
    data: {
      id
    }
  });
};
